import type { Room } from '@studio/models/room';

export const queryKeys = {
  // Account scopes the room so a signed-in switch cannot reuse the previous
  // account's agent enumeration for the same studio.
  agentStatus: (roomId: Room['id'], accountId?: string | null) =>
    accountId ? (['agentStatus', roomId, accountId] as const) : (['agentStatus', roomId] as const),
  machineAgentId: () => ['getMachineAgentId'] as const
};
